import { formatNameLastFirst, formatPhoneNumber } from '@strata/helper-functions';
import { FormSectionWithRows } from '@strata/react-form-section';
import { AddressDetailLabelValue, DetailLabelValuePair } from '@strata/react-label-value-pairs';

import { type PrescriberDetails as PrescriberDetailsInterface } from 'store/api/referenceApi';

interface PrescriberDetailsProps {
    prescriberDetails?: PrescriberDetailsInterface;
    isLoading?: boolean;
}

export const PrescriberDetails = ({
    prescriberDetails = undefined,
    isLoading = true,
}: PrescriberDetailsProps) => (
    <FormSectionWithRows
        sectionTitle="Prescriber Details"
        isLoading={isLoading}
        rowOneContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Prescriber"
                    value={prescriberDetails?.name}
                />
                <DetailLabelValuePair label="Prescriber NPI" value={prescriberDetails?.npi} />
            </>
        }
        rowTwoContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Phone"
                    value={formatPhoneNumber(prescriberDetails?.phone)}
                />
                <DetailLabelValuePair
                    label="Fax"
                    value={formatPhoneNumber(prescriberDetails?.fax)}
                />
            </>
        }
        rowThreeContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Point Of Contact"
                    value={formatNameLastFirst(
                        prescriberDetails?.pointOfContactLastName,
                        prescriberDetails?.pointOfContactFirstName,
                    )}
                />
                <DetailLabelValuePair
                    label="Point Of Contact Phone"
                    value={formatPhoneNumber(prescriberDetails?.pointOfContactPhone)}
                />
            </>
        }
        rowFourContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Practice"
                    value={prescriberDetails?.organizationName}
                />
                <DetailLabelValuePair label="Practice NPI" value={prescriberDetails?.practiceNpi} />
            </>
        }
        rowFiveContent={
            <AddressDetailLabelValue
                style={{ width: '50%' }}
                label="Practice Address"
                address1={prescriberDetails?.address1}
                address2={prescriberDetails?.address2}
                city={prescriberDetails?.city}
                state={prescriberDetails?.state}
                zip={prescriberDetails?.zip}
            />
        }
    />
);
